// @ts-nocheck — legacy auth saga; will be replaced in Phase 1 with LeadNova auth
import { call, put } from "redux-saga/effects";
import { ACTIONS, API_URL, STORAGE } from "../_config";
import { CallApi } from "./api/callApi";

export function* loginUser(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.LOGIN, action.payload, false);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      localStorage.setItem(STORAGE, resp.data.data?.token);
      yield put({ type: ACTIONS.AUTH.LOGIN, payload: { user: resp.data.data?.user, token: resp.data.data?.token } });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* registration(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.REGISTER, action.payload, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      localStorage.setItem(STORAGE, resp.data.data?.token);
      yield put({ type: ACTIONS.AUTH.LOGIN, payload: { user: resp.data.data?.user, token: resp.data.data?.token } });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* forgotPassword(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.FORGOT_PASSWORD, action.payload, true);
    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* resetPassword(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.RESET_PASSWORD, action.payload, true);
    if (resp.status >= 200 && resp.status < 300) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* logoutUser(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.AUTH.LOGOUT, action.payload, true);
    if (resp.status >= 200 && resp.status < 300) {
      localStorage.removeItem(STORAGE);
      yield put({ type: ACTIONS.AUTH.LOGOUT });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getUserProfile(action: any): any {
  try {
    const resp = yield call(CallApi.GET, API_URL.AUTH.ME, action.payload, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data) {
      yield put({ type: ACTIONS.AUTH.LOGIN, payload: { user: resp.data.data?.user, token: localStorage.getItem(STORAGE) } });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    yield put({ type: ACTIONS.AUTH.LOGOUT });
  }
}

export function* updateUserProfile(action: any): any {
  try {
    const resp = yield call(CallApi.POST, API_URL.SETTINGS.PROFILE, action.payload, true);
    if (resp.status >= 200 && resp.status < 300) {
      yield put({ type: ACTIONS.AUTH.ME, payload: "user" });
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}
